export const SectionCard = ({ title, subtitle, action, children, className = '', bodyClassName = '', testid }) => (
  <div className={`rounded-2xl border bg-card card-shadow ${className}`} data-testid={testid}>
    {(title || action) && (
      <div className="flex items-start justify-between gap-3 px-5 pt-5">
        <div>
          {title && <h3 className="font-display text-base font-semibold tracking-tight text-foreground">{title}</h3>}
          {subtitle && <p className="mt-0.5 text-xs text-muted-foreground">{subtitle}</p>}
        </div>
        {action}
      </div>
    )}
    <div className={`px-5 pb-5 pt-4 ${bodyClassName}`}>{children}</div>
  </div>
);
